import React, { useEffect, useState } from 'react';
export function Countdown() {
  // 15 minutes countdown resetting
  const [timeLeft, setTimeLeft] = useState(15 * 60);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) return 15 * 60; // reset
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="flex items-center justify-center space-x-2 text-lime-400 font-display text-2xl mb-4" data-id="element-163">
      <span className="bg-dark-800 px-3 py-1 rounded border border-lime-400/30" data-id="element-164">
        {minutes.toString().padStart(2, '0')}
      </span>
      <span data-id="element-165">:</span>
      <span className="bg-dark-800 px-3 py-1 rounded border border-lime-400/30" data-id="element-166">
        {seconds.toString().padStart(2, '0')}
      </span>
    </div>;
}